angular.module('impactx.osu').controller('ValidateSelfRegistrationCtrl', ['$scope', 'dataGen', '$routeParams', 'AppConfiguration', ValidateSelfRegistrationCtrl]);

function ValidateSelfRegistrationCtrl($scope, dataGen, $routeParams, AppConfiguration)
{
    this.logoUrl = AppConfiguration.get('loginPageLogoUrl');

    dataGen.getData({}, {osutan: $routeParams.tan}, "/user/registration/validatemail").then(function (data) {
        if (!data.data.errorMessage) {
            $scope.message1 = data.data.message1;
            $scope.message2 = data.data.message2;
        }
        else {
            $scope.errorMessage = data.data.errorMessage;
        }
    });
}